/* Syntax compiled to ES2018; source and reproducible build: docs/analysis/2026-11-02-clarity-fixes. */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.addEventListener("click", (evt) => {
      if (evt.target.id === "CartDrawer-Overlay") this.close();
    });
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  async open(triggeredBy, { refresh = true } = {}) {
    var _a, _b, _c;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (refresh) {
      triggeredBy == null ? void 0 : triggeredBy.setAttribute("aria-busy", "true");
      document.documentElement.classList.add("sp-cart-loading");
      try {
        if (!await this.refreshContents()) return;
      } catch (error) {
        window.location.assign((((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/") + "cart");
        return;
      } finally {
        triggeredBy == null ? void 0 : triggeredBy.removeAttribute("aria-busy");
        document.documentElement.classList.remove("sp-cart-loading");
      }
    }
    (_c = window.spDrawerAB) == null ? void 0 : _c.render();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
      document.dispatchEvent(new CustomEvent("sp:drawer-opened"));
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden");
  }
  close() {
    this.cancelRefresh();
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  cancelRefresh() {
    var _a;
    this.refreshId = (this.refreshId || 0) + 1;
    (_a = this.refreshController) == null ? void 0 : _a.abort();
  }
  async refreshContents() {
    var _a, _b;
    this.cancelRefresh();
    const requestId = this.refreshId;
    const controller = this.refreshController = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8e3);
    try {
      const url = new URL((((_b = (_a = window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root) || "/") + "cart", location.origin);
      url.searchParams.set("sections", "cart-drawer,cart-icon-bubble");
      url.searchParams.set("_sp", Date.now());
      const response = await fetch(url, { cache: "no-store", signal: controller.signal });
      if (!response.ok) throw new Error("Cart refresh failed");
      const sections = await response.json();
      if (requestId !== this.refreshId) return false;
      this.applySections(sections);
      return true;
    } catch (error) {
      if (requestId !== this.refreshId) return false;
      throw error;
    } finally {
      clearTimeout(timeout);
    }
  }
  applySections(sections) {
    const fresh = this.getSectionDOM((sections == null ? void 0 : sections["cart-drawer"]) || "", "#CartDrawer");
    if (!(fresh == null ? void 0 : fresh.querySelector("[data-sp-cart-state]"))) throw new Error("Missing cart section");
    this.querySelector("#CartDrawer").innerHTML = fresh.innerHTML;
    const state = JSON.parse(this.querySelector("[data-sp-cart-state]").textContent);
    this.classList.toggle("is-empty", state.item_count === 0);
    const bubble = document.getElementById("cart-icon-bubble");
    if (bubble && sections["cart-icon-bubble"]) {
      bubble.innerHTML = this.getSectionInnerHTML(sections["cart-icon-bubble"]);
    }
    document.dispatchEvent(new CustomEvent("sp:cart-updated"));
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });
    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.cancelRefresh();
    if (!this.classList.contains("active")) this.setActiveElement(document.activeElement);
    this.productId = parsedState.id;
    this.applySections(parsedState.sections);
    this.open(void 0, { refresh: false });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer"
      },
      {
        id: "cart-icon-bubble"
      }
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
